import React from "react";

import { observer } from "mobx-react";
import {
	getFormatedCombinationQuota,
	getSystemIdentifierString,
} from "@utils/my-bets/helpers";
import { useTranslation } from "react-i18next";

export const CombinationItem = observer(function CombinationItem(props: {
	combination: {
		combinationOffers: {
			systemIdentifier: string[];
		}[];
		combinationStatus: number;
		combinationQuota: number;
	};
	ordinalNumber: string;
}) {
	const { t } = useTranslation("mybets");

	const mapStatus = (status: number): string => {
		switch (status) {
			case 1:
				return "ITEM.BET_SLIP_COMBINATIONS.OPEN";
			case 2:
				return "ITEM.BET_SLIP_COMBINATIONS.WON";
			case 3:
				return "ITEM.BET_SLIP_COMBINATIONS.LOST";
			default:
				return "ITEM.BET_SLIP_COMBINATIONS.OPEN";
		}
	};

	return (
		<tr className="table--bet__body__row">
			<td className="table--bet__body__data">{props.ordinalNumber}</td>
			<td className="table--bet__body__data">
				{getSystemIdentifierString(props.combination.combinationOffers)}
			</td>
			<td className="table--bet__body__data">
				{getFormatedCombinationQuota(
					props.combination.combinationQuota
				)}
			</td>
			{/* This will prob change but leave for now like this */}
			<td className="table--bet__body__data">
				{t(mapStatus(props.combination.combinationStatus))}
			</td>
		</tr>
	);
});
